import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1.5, 2),
    paddingLeft: theme.spacing(6), // Space for search icon
    paddingRight: theme.spacing(5), // Space for clear button
    transition: theme.transitions.create(["width", "box-shadow"], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.short,
    }),
    width: "100%",
    fontSize: "0.95rem",
    fontWeight: 400,
    lineHeight: 1.5,
    "&::placeholder": {
      color: theme.palette.text.secondary,
      opacity: 0.8,
    },
    [theme.breakpoints.up("sm")]: {
      width: "240px",
      "&:focus": {
        width: "320px",
      },
    },
    [theme.breakpoints.up("md")]: {
      width: "280px",
      "&:focus": {
        width: "380px",
      },
    },
  },
}));
